import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/fms/fms_vehicles`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}





function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_vehicles/${id}`, options)
    .then(response => {
      let fms_vehicles = jsona.deserialize(response.data);
      delete fms_vehicles.links;
      return fms_vehicles;
    });
}

function add(fms_vehicles) {
  
  console.log(fms_vehicles);
  const payload = jsona.serialize({
    stuff: fms_vehicles,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/fms/fms_vehicles`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(fms_vehicles) {
  const payload = jsona.serialize({
    stuff: fms_vehicles,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/fms/fms_vehicles/${fms_vehicles.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {``
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/fms/fms_vehicles/${id}`, options);
}

function get_mileage_mspf(data) {
  
  // console.log(data);
  // const payload = jsona.serialize({
  //   stuff: data,
  //   includeNames: null
  // });
  // console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/fms/fms_vehicle/mspf/mileage`, data, options)
    .then(response => {
      return response.data;
    });
}


// function last_no() {
//   const options = {
//     headers: {
//       'Accept': 'application/vnd.api+json',
//       'Content-Type': 'application/vnd.api+json',
//     }
//   };

//   return axios.get(`${url}/fms_vehicles/last/no`, options)
//     .then(response => {
//       return response.data;
//     });
// }


export default {
  list,
  get,
  add,
  update,
  destroy,
  get_mileage_mspf
};

